import { Button } from '@eventbrite/marmalade';
import { AvatarComponent } from '../AvatarComponent/AvatarComponent';
import { Organizer } from '@/types';
import { useIntl } from 'react-intl';
import styles from './DialogContent.module.scss';

export interface DialogContentProps {
  organizer: Organizer;
  closeDialog: () => void;
}

export const DialogContent: React.FC<DialogContentProps> = ({ organizer, closeDialog }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.dialogContent}>
      <AvatarComponent organizer={organizer} clickable={false} />
      <div className={styles.dialogTitle}>{formatMessage({ id: 'This organizer is verified!' })}</div>
      <div className={styles.dialogDescription}>
        {formatMessage({
          id: "We've met these event organizers and confirmed their identity. They bring you unique things to do on Eventbrite.",
        })}
      </div>
      <Button className={styles.button} onClick={closeDialog}>
        {formatMessage({ id: 'Got it' })}
      </Button>
    </div>
  );
};
